import PoolListCmp from '@/component/pools/PoolListCmp';

export default function PoolList() {
  return <PoolListCmp type='list' />;
}
